import { apiClient } from "./client";

export interface BusinessResult {
  id: string;
  displayName: string;
  slug: string;
  bio: string | null;
  category: string;
  avatarUrl: string | null;
  coverUrl: string | null;
  city: string | null;
  state: string | null;
  latitude: number;
  longitude: number;
  distance: number;
  ownerName: string;
}

export interface FeedPost {
  id: string;
  caption: string | null;
  likeCount: number;
  commentCount: number;
  createdAt: string;
  businessName: string;
  businessSlug: string;
  businessAvatarUrl: string | null;
  businessCategory: string;
  imageUrl: string | null;
}

export interface CategoryCount {
  category: string;
  count: number;
}

export async function searchBusinesses(params: {
  lat: number;
  lng: number;
  radius?: number;
  category?: string;
  query?: string;
  page?: number;
}) {
  const qs = new URLSearchParams({
    lat: String(params.lat),
    lng: String(params.lng),
  });
  if (params.radius) qs.set("radius", String(params.radius));
  if (params.category) qs.set("category", params.category);
  if (params.query) qs.set("query", params.query);
  if (params.page) qs.set("page", String(params.page));

  return apiClient<{ businesses: BusinessResult[]; page: number; limit: number }>(
    `/explore?${qs.toString()}`
  );
}

export async function getExploreFeed(params: {
  lat: number;
  lng: number;
  radius?: number;
  page?: number;
}) {
  const qs = new URLSearchParams({
    lat: String(params.lat),
    lng: String(params.lng),
  });
  if (params.radius) qs.set("radius", String(params.radius));
  if (params.page) qs.set("page", String(params.page));

  return apiClient<{ posts: FeedPost[]; page: number; limit: number }>(
    `/explore/feed?${qs.toString()}`
  );
}

export async function getCategories() {
  return apiClient<{ categories: CategoryCount[] }>("/explore/categories");
}
